import React from "react";
import styled from "styled-components";
/* import FadeAnimation from "./FadeAnimation"; */
import LInsvall_1 from "../images/food.webp";
import LInsvall_2 from "../images/vacan1.webp";
import LInsvall_3 from "../images/transpic2.webp";
import LInsvall_4 from "../images/ocf.webp";

import Newspic from "../images/newslogo.avif";

function IntegraAllNews() {
  return (
    <LatestIntegralAllNews>
      <h2>Latest news</h2>
      <div className="allnewshero">
        <div className="galcon">
          <div className="gitem">
            <img src={Newspic} alt="" />
          </div>
        </div>

        <div className="galcon">
          <div className="gitem">
            The freight forwarding industry is experiencing significant
            developments. FedEx plans to spin off its freight division into a
            new, publicly traded company named FedEx Freight, aiming to enhance
            shareholder value and operational focus. MarketWatch Additionally,
            mergers and acquisitions are resurging as freight markets stabilize
            post-pandemic, with notable deals like DSV's $12 billion acquisition
            of DB Schenker. The Wall Street Journal Technological advancements
            continue to reshape the sector, with platforms like WebCargo
            enabling digital bookings with major airlines, representing about
            70% of global cargo capacity. Wikipedia These trends indicate a
            dynamic shift towards increased specialization, consolidation, and
            digitization in freight forwarding.
          </div>
        </div>
      </div>
      <div className="LatestInsightVallGrid">
        {LatestInsightsData.map((LatestInsight) => (
          <div className="gallery-container">
            {/*this is for one object: start here */}
            <div className="gallery-iitem">
              <div className="image">
                <img
                  src={LatestInsight.img}
                  alt={LatestInsight.LatestInsight}
                />
                <div className="text">{LatestInsight.Title}</div>
                <br />
                <div>{LatestInsight.desc}</div>
              </div>
            </div>
            {/*this is for one object: end here */}
          </div>
        ))}
      </div>
    </LatestIntegralAllNews>
  );
}

export default IntegraAllNews;

export const LatestInsightsData = [
  {
    id: "Linst1",
    Title: "Resilience",
    /*   price: 45, */
    desc: "The role of refrigerated warehousing in keeping cold chains stable",
    img: LInsvall_1,
    LearnMore: `/ProjectCargoCon`,
  },

  {
    id: "Linst2",
    Title: "Resilience",
    /*   price: 45, */
    desc: "Project cargo is the transportation of any item that is too big or too heavy to fit into an ocean freight container or a truck trailer. These oversize and heavy items are often complex to transport and require an individualized plan to move domestically or internationally",
    img: LInsvall_2,
    LearnMore: `/ProjectCargoCon`,
  },

  {
    id: "Linst3",
    Title: "Resilience",
    /*   price: 45, */
    desc: "Project cargo is the transportation of any item that is too big or too heavy to fit into an ocean freight container or a truck trailer. These oversize and heavy items are often complex to transport and require an individualized plan to move domestically or internationally",
    img: LInsvall_3,
    LearnMore: `/ProjectCargoCon`,
  },

  {
    id: "svr4",
    Title: "Resilience",
    /*   price: 45, */
    desc: "Project cargo is the transportation of any item that is too big or too heavy to fit into an ocean freight container or a truck trailer. These oversize and heavy items are often complex to transport and require an individualized plan to move domestically or internationally",
    img: LInsvall_4,
    LearnMore: `/ProjectCargoCon`,
  },
];

const LatestIntegralAllNews = styled.div`
  width: 75vw;
  margin-left: calc((100vw - 75vw) / 2);
  margin-right: calc((100vw - 75vw) / 2);

  .LatestInsightVallGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: -50px;
  }

  .gallery-iitem {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .gallery-iitem .image {
    width: 100%;
    height: 70%;
  }
  .gallery-iitem .image img {
    width: 100%;
    height: 70%;
    object-fit: cover;
    object-position: 50% 50%;
    cursor: pointer;
    /*   transition: 0.5s ease-in-out; */
  }

  .allnewshero {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 50px;
  }

  .gitem {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .gitem .image {
    width: 100%;
    height: 100%;
  }

  .gitem img {
    width: 100%;
    height: 70%;
    object-fit: cover;
    object-position: 50% 50%;
    cursor: pointer;
    /*   transition: 0.5s ease-in-out; */
  }
`;
